import { Component, inject } from "@angular/core";
import { Router, RouterLink, RouterOutlet } from "@angular/router";
import { MatTabNav, MatTabLink, MatTabNavPanel } from "@angular/material/tabs";

@Component({
  selector: "app-system-admin-home",
  templateUrl: "./system-admin-home.component.html",
  styleUrls: ["./system-admin-home.component.css"],
  imports: [MatTabNav, MatTabLink, RouterLink, MatTabNavPanel, RouterOutlet]
})
export class SystemAdminHomeComponent {
  private router = inject(Router);

  activeLink: string = "";

  constructor() {
    const router = this.router;

    this.activeLink = router.url;
  }
}
